import { render, staticRenderFns } from "./SidekickSearch.vue?vue&type=template&id=0a8e4fd9&"
import script from "./SidekickSearch.vue?vue&type=script&lang=js&"
export * from "./SidekickSearch.vue?vue&type=script&lang=js&"
import style0 from "./SidekickSearch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports